import React, { useState } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar';
import {useNavigate, Link} from 'react-router-dom';

export default function UploadVoiceForm() {
  const [date, setDate] = useState('');
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState('');

  const nav = useNavigate()

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setFile(reader.result); // base64
    };

    if (selected) reader.readAsDataURL(selected);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Uploading...');

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/admin/news-voice/upload`, {
        date,
        file,
      });

      setStatus(`✅ Uploaded successfully!`);
      nav('/news-voice');
      setDate('');
      setFile(null);
    } catch (err) {
      console.error(err);
      setStatus('❌ Upload failed');
    }
  };

  return (
    <>

<div className="sidebar">
<Sidebar/>
</div>
    <div id="tabler">
        <h1>News Voice</h1>
      <form onSubmit={handleSubmit}>
        <input className='form-control' type="date" required onChange={(e) => setDate(e.target.value)} />
        <br></br>
        <input className='form-control' type="file" accept="audio/*" required onChange={handleFileChange} />
        <br></br>
        <button className='btn btn-primary' type="submit">Submit</button>
        <Link className='btn btn-danger' style={{marginLeft: 20}} >Cancel</Link>
      </form>
        <br></br>
      {status && <p>{status}</p>}
    </div>
</>
  );
}
